import {useState, useEffect} from 'react';
import {getMemberIdByDeviceId, handleTokenResponse, login} from '../../api/authApi';
import {Link, useNavigate} from 'react-router-dom';

import axios, {AxiosError} from 'axios';
import {defaultAlert} from "../../utils/alert";
import useFirebaseToken from "../../hooks/useFireBaseToken";
import {getCompanyInfo} from "../../api/commonApi";
import useDeviceId from "../../hooks/useDeviceId";
import {isNullOrEmpty} from "../../utils/validation";

export default function LoginPage() {
    const [memberId, setMemberId] = useState('');
    const [password, setPassword] = useState('');
    const [csNumber, setCsNumber] = useState('');
    const [checkSaveId, setCheckSaveId] = useState<boolean>(false);
    const {fcmToken, deviceType, isTokenReady} = useFirebaseToken();
    const {deviceId, isDeviceIdReady} = useDeviceId();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCsNumber = async () => {
            try {
                const res = await getCompanyInfo();
                const info = res.data?.data;
                if (info?.customerService) {
                    setCsNumber(info.customerService);
                }
            } catch (error) {
                console.error('Failed to fetch company i\nnfo:', error);
            }
        };
        fetchCsNumber();
    }, []);


    useEffect(() => {
        if (!isDeviceIdReady) {
            console.warn("deviceId 준비 중...");
            return;
        }
        const getMemberId = async () => {
            try {
                const response = await getMemberIdByDeviceId(deviceId || "isPc");
                // 존재하면 id 뿌려주고 아이디 저장 체크박스에 체크
                if (response.data.code === "00") {
                    setMemberId(response.data.data);
                    setCheckSaveId(true);
                } else {
                    setCheckSaveId(false);
                }
            } catch (error) {
                console.error('Failed to fetch getMemberId:', error);
            }
        };
        getMemberId();
    }, [isDeviceIdReady]);


    const handleCheckSaveId = (check: boolean) => {
        setCheckSaveId(check);
    };

    const isAxiosError = (error: unknown): error is AxiosError => {
        return axios.isAxiosError(error);
    };

    const handleLogin = async () => {

        if (!isTokenReady) {
            console.warn("FCM 토큰 준비 중...");
            return;
        }

        if (isNullOrEmpty(memberId)) {
            defaultAlert("아이디를 입력해주세요.");
            return;
        }
        if (isNullOrEmpty(password)) {
            defaultAlert("비밀번호를 입력해주세요.");
            return;
        }

        try {
            const res = await login({
                memberId,
                password,
                fcmToken,
                deviceType,
                deviceId: checkSaveId ? deviceId : null
            });

            const tokenCode = res.data.code;
            const tokenData = res.data.data;

            if(tokenCode == "00") {
                if (tokenData.accessToken && tokenData.refreshToken) {
                    handleTokenResponse(res.data);
                    navigate('/');
                } else {
                    defaultAlert('토큰 정보가 없습니다.');
                }
            } else if(tokenCode == "A019") {
                handleTokenResponse(res.data);
                navigate('/login-password');
            }
        } catch (error) {
            if (isAxiosError(error)) {
                handleLoginError(error);
            } else {
                defaultAlert('예기치 않은 오류가 발생했습니다.');
                console.error('Unknown error:', error);
            }
        }
    };

    return (
        <>
            <div className="bottom-btn">
                <div className="text-box">
                    {csNumber && (
                        <p className="bottom-guide">
                            고객센터&nbsp;&nbsp;<strong>{csNumber}</strong>
                        </p>
                    )}
                </div>
            </div>

            <header className="sub-header">
                <div className="header-inner">
                    <button
                        type="button"
                        className="closeBtn"
                        onClick={() => navigate('/')}
                    >
                        <span className="blind">닫기</span>
                    </button>
                </div>
            </header>

            <main className="container">
                <section>
                    <div className="inner">
                        <div className="login-logo">
                            <p className="txt">서비스 이용을 위해 로그인해 주세요.</p>
                        </div>

                        <form className="form-box login" onSubmit={e => e.preventDefault()}>
                            <div className="form-item">
                                <div className="input-box">
                                    <i className="fa fa-user" aria-hidden="true"></i>
                                    <input
                                        type="text"
                                        id="UserID"
                                        name="UserID"
                                        placeholder="ID"
                                        value={memberId}
                                        onChange={e => setMemberId(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="input-box">
                                    <i className="fa fa-unlock-alt" aria-hidden="true"></i>
                                    <input
                                        type="password"
                                        id="UserPW"
                                        name="UserPW"
                                        placeholder="Password"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="default-checkbox">
                                    <input
                                        type="checkbox"
                                        className="input"
                                        id="saveIdCheck"
                                        checked={checkSaveId}
                                        onChange={e => handleCheckSaveId(e.target.checked)}
                                    />
                                    <label htmlFor="saveIdCheck">아이디 저장</label>
                                </div>
                            </div>

                            <div className="form-item">
                                <button
                                    type="button"
                                    className="confirm-btn"
                                    onClick={handleLogin}
                                >
                                    로그인
                                </button>
                            </div>

                            <div className="form-item">
                                <ul className="text-btn-list">
                                    <li>
                                        <Link to="/find-id">아이디 찾기</Link>
                                    </li>
                                    <li className="none">
                                        <Link to="/find-password">비밀번호 찾기</Link>
                                    </li>
                                </ul>
                            </div>

                            <div className="form-item">
                                <button
                                    type="button"
                                    className="default-btn"
                                    onClick={() => navigate('/signup/terms')}
                                >
                                    회원가입
                                </button>
                            </div>

                        </form>
                    </div>
                </section>
            </main>
        </>
    );
}

export const handleLoginError = (error: AxiosError<any>) => {
    const status = error.response?.status;
    const message = error.response?.data?.message;

    switch (status) {
        case 401:
            defaultAlert('아이디 또는 비밀번호가 일치하지 않습니다.');
            break;
        case 400:
            defaultAlert(message || '입력값이 올바르지 않습니다.');
            break;
        case 500:
            defaultAlert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
            break;
        default:
            defaultAlert('로그인 중 오류가 발생했습니다.');
    }
    console.error('로그인 에러:', error);
};